const locale = {
  placeholder: 'Vali aeg',
};

export default locale;



// WEBPACK FOOTER //
// ./components/time-picker/locale/et_EE.tsx